// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_total_days_in_month.ts
var e = (e) => {
	let t = e.getFullYear(), n = e.getMonth();
	return new Date(t, n + 1, 0).getDate();
};
export { e as get_total_days_in_month };

//# sourceMappingURL=get_total_days_in_month.js.map